<template>
  <div>
    <settings-top-nav :selectedBinId="selectedBinInfo.bin_id" :componentname="selectedBinComponent"
    @changeToSelectedBinComponent='changeSelectedBinComponent' :showAddBinButton="selectedBinComponent != 'add-bin'"></settings-top-nav>
    <component :is="selectedBinComponent"
    :selectedBinId="selectedBinInfo.bin_id"
    @changeToSelectedBinComponent='changeSelectedBinComponent'
     v-bind="currentProperties"></component>
  </div>
</template>

<script>
import AddBin from "./AddBin.vue"
import ShowBins from "./ShowBins.vue"
import BinsInfo from "./BinInfo.vue"
import settingsTopNav from "./HeaderBar.vue"

export default {
  name: "Bins",
  data() {
    return {
      selectedBinComponent: ShowBins,
      selectedBinInfo: {}
    };
  },
  components: {
    "add-bin": AddBin,
    "bins-info": BinsInfo,
    "settings-top-nav": settingsTopNav,
    "show-bins": ShowBins
  },
  methods: {
    changeSelectedBinComponent(compName, binInfo={}) {
      this.selectedBinComponent = compName;
      this.selectedBinInfo = binInfo;
    },
    showBinsTopNav() {
      let comps = [
        "add-bin",
        "bins-info"
      ];
      if (comps.indexOf(this.selectedBinComponent) > -1) {
        return true;
      }
    }
  },
  computed:{
      currentProperties() {
      if (this.selectedBinComponent === "bins-info") {
        return { selectedBinID : this.selectedBinInfo.bin_id};
      }
      else{
          return {}
      }
    },
  }
};
</script>

<style scoped>

</style>